import { MDXProvider } from "@mdx-js/react";
import { generateDefaultSeo } from "next-seo/pages";
import { ThemeProvider } from "next-themes";
import Head from "next/head";
import { useRouter } from "next/router";
import SEO from "#next-seo.config";
import MDXComponents from "~/components/MDXComponents";
import { isProduction, umamiWebsiteId } from "~/config";
import { isUnindexed } from "~/lib/routes";
import "~/styles/global.scss";
// import { useAnalytics } from '@/lib/analytics';

export default function App({ Component, pageProps }) {
  // useAnalytics();
  const router = useRouter();

  return (
    <ThemeProvider attribute="class">
      <MDXProvider components={MDXComponents}>
        <Head>
          <meta content="width=device-width, initial-scale=1" name="viewport" />
          {/* Before the page, so a page's own image replaces this one; pages without one still get a card. */}
          {generateDefaultSeo({
            openGraph: { images: SEO.openGraph.images },
            twitter: { ...SEO.twitter, cardType: "summary" }
          })}
          {isProduction && (
            // data-exclude-hash: following a link to one of the page's own sections isn't a new page view.
            <script
              defer
              src="https://analytics.sambatista.com/script.js"
              data-website-id={umamiWebsiteId}
              data-exclude-hash="true"
            ></script>
          )}
        </Head>
        <Component {...pageProps} />
        {isUnindexed(router.pathname, router.asPath) && (
          // After the page, so it replaces the page's own robots tag: next-seo keys its tag "robots" too.
          <Head>
            <meta name="robots" content="noindex,follow" key="robots" />
          </Head>
        )}
      </MDXProvider>
    </ThemeProvider>
  );
}
